import React from 'react';

export default function PanelCapas({ layerVisibility, toggleLayer, hasRenabapData = false, hasRppvapData = false, hasRenabapTargets = false, hasRppvapTargets = false, showBeneficiarios = false, showArba = false }) {
  return (
    <div className="bg-white bg-opacity-95 rounded-lg shadow-lg p-3">
      <h3 className="text-xs font-semibold text-gray-500 uppercase mb-2">Capas</h3>
      <div className="space-y-1.5">
        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input type="checkbox" checked={layerVisibility.partido} onChange={() => toggleLayer('partido')} className="rounded" />
          <span className="w-3 h-3 rounded-sm inline-block shrink-0" style={{ backgroundColor: 'rgba(255,0,0,0.5)' }} />
          <span className="truncate">Partido</span>
        </label>
        {hasRenabapData && (
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={layerVisibility.renabap} onChange={() => toggleLayer('renabap')} className="rounded" />
            <span className="w-3 h-3 rounded-sm inline-block shrink-0" style={{ backgroundColor: 'rgba(33,150,243,0.5)' }} />
            <span className="truncate">Barrios RENABAP</span>
          </label>
        )}
        {hasRppvapData && (
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={layerVisibility.rppvap} onChange={() => toggleLayer('rppvap')} className="rounded" />
            <span className="w-3 h-3 rounded-sm inline-block shrink-0" style={{ backgroundColor: 'rgba(76,175,80,0.5)' }} />
            <span className="truncate">Barrios RPPVAP</span>
          </label>
        )}
        {hasRenabapTargets && (
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={layerVisibility.renabapTarget} onChange={() => toggleLayer('renabapTarget')} className="rounded" />
            <span className="w-3 h-3 rounded-sm inline-block shrink-0" style={{ backgroundColor: 'rgba(33,150,243,0.7)' }} />
            <span className="truncate">RENABAP seleccionado</span>
          </label>
        )}
        {hasRppvapTargets && (
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={layerVisibility.rppvapTarget} onChange={() => toggleLayer('rppvapTarget')} className="rounded" />
            <span className="w-3 h-3 rounded-sm inline-block shrink-0" style={{ backgroundColor: 'rgba(76,175,80,0.7)' }} />
            <span className="truncate">RPPVAP seleccionado</span>
          </label>
        )}
        {showBeneficiarios && (
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={layerVisibility.beneficiarios} onChange={() => toggleLayer('beneficiarios')} className="rounded" />
            <span className="w-3 h-3 rounded-sm inline-block shrink-0" style={{ backgroundColor: '#2196F3' }} />
            <span className="truncate">Beneficiarios</span>
          </label>
        )}
        {showArba && (
          <label className="flex items-center gap-2 text-sm cursor-pointer">
            <input type="checkbox" checked={layerVisibility.arba} onChange={() => toggleLayer('arba')} className="rounded" />
            <span className="w-3 h-3 rounded-sm inline-block shrink-0" style={{ backgroundColor: '#9c27b0' }} />
            <span className="truncate">CartoARBA</span>
          </label>
        )}
      </div>
    </div>
  );
}
